import { render, staticRenderFns } from "./AdminMonitoring.vue?vue&type=template&id=89f0bc00&scoped=true"
import script from "./AdminMonitoring.vue?vue&type=script&lang=js"
export * from "./AdminMonitoring.vue?vue&type=script&lang=js"
import style0 from "./AdminMonitoring.vue?vue&type=style&index=0&id=89f0bc00&prod&lang=css"
import style1 from "./AdminMonitoring.vue?vue&type=style&index=1&id=89f0bc00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f0bc00",
  null
  
)

export default component.exports